import { render } from "./SignUpWelcome.vue?vue&type=template&id=dde75ee8&scoped=true&ts=true"
import script from "./SignUpWelcome.vue?vue&type=script&lang=ts"
export * from "./SignUpWelcome.vue?vue&type=script&lang=ts"

import "./SignUpWelcome.vue?vue&type=style&index=0&id=dde75ee8&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dde75ee8"]])

export default __exports__